export default "__VITE_ASSET__BQmJrvj$__"